module.exports = __webpack_public_path__ + "img/status-ko.69d82ff8.png";